// src/TesterApiOdoo.js
import React, { useState } from 'react';

const TesterApiOdoo = () => {
    const [brokerName, setBrokerName] = useState('');
    const [brokerEmail, setBrokerEmail] = useState('');
    const [urlLink, setUrlLink] = useState(null);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        if (!brokerName || !brokerEmail) {
            alert('Veuillez remplir tous les champs.');
            return;
        }

        const payload = {
            broker_name: brokerName,
            broker_email: brokerEmail
        };

        try {
            const response = await fetch('https://ecpy-test-19029946.dev.odoo.com/api/order_token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            console.log('Réponse de l\'API:', data);

            const url = data.result[0]?.url;
            if (!url) {
                throw new Error('Aucune URL générée par l\'API');
            }

            setUrlLink(url);

            // Redirection vers l'URL après un délai de 2 secondes
            setTimeout(() => {
                window.location.href = url;
            }, 2000);

        } catch (err) {
            console.error('Erreur:', err);
            setError('Une erreur s\'est produite lors de l\'appel à l\'API. Vérifiez la console pour plus de détails.');
        }
    };

    return (
        <div className="container">
            <h1>Tester l'API Odoo</h1>
            <div className="form-group">
                <label htmlFor="broker_name">Nom du courtier</label>
                <input
                    type="text"
                    id="broker_name"
                    placeholder="Entrez le nom du courtier"
                    value={brokerName}
                    onChange={(e) => setBrokerName(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label htmlFor="broker_email">Email du courtier</label>
                <input
                    type="text"
                    id="broker_email"
                    placeholder="Entrez l'email du courtier"
                    value={brokerEmail}
                    onChange={(e) => setBrokerEmail(e.target.value)}
                />
            </div>
            <button onClick={handleSubmit}>Générer le lien</button>

            {urlLink && (
                <div id="response" className="response">
                    <strong>URL générée:</strong> <span id="url_link">{urlLink}</span>
                </div>
            )}

            {error && <div className="response" style={{ color: 'red' }}>{error}</div>}

            <style jsx>{`
                .container {
                    background-color: white;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    width: 400px;
                    margin: 0 auto;
                }

                h1 {
                    font-size: 24px;
                    margin-bottom: 20px;
                    text-align: center;
                }

                .form-group {
                    margin-bottom: 15px;
                }

                label {
                    font-size: 14px;
                    margin-bottom: 5px;
                    display: block;
                }

                input[type="text"] {
                    width: 100%;
                    padding: 8px;
                    border-radius: 4px;
                    border: 1px solid #ccc;
                    font-size: 14px;
                }

                button {
                    width: 100%;
                    padding: 10px;
                    background-color: #28a745;
                    color: white;
                    font-size: 16px;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                }

                button:hover {
                    background-color: #218838;
                }

                .response {
                    margin-top: 20px;
                    font-size: 14px;
                    padding: 10px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    background-color: #f8f9fa;
                }
            `}</style>
        </div>
    );
};

export default TesterApiOdoo;
